module.exports = __webpack_public_path__ + "img/img26.2d2b7c1b.svg";